<template>
  <div v-if="value" class="overlay" @click.self="close">
    <div class="modal-box">
      <div class="modal-head">
        <h3 class="modal-title">{{ form.id ? 'Mahsulotni tahrirlash' : 'Yangi mahsulot' }}</h3>
        <button class="close-btn" @click="close">&times;</button>
      </div>

      <div class="modal-body">
        <div class="image-uploader" @click="$refs.fileInput.click()">
          <img v-if="previewUrl" :src="previewUrl" alt="rasm" />
          <div v-else class="image-placeholder">
            <div>📦</div>
            <div>Rasm tanlang</div>
          </div>
          <input ref="fileInput" type="file" accept="image/*" hidden @change="onFileChange" />
        </div>

        <div class="field-group">
          <label class="flabel">Nomi</label>
          <input v-model="form.name" type="text" class="finput" placeholder="Smartphone Redmi 13" @keyup.enter="save" />
        </div>

        <div class="field-group">
          <label class="flabel">Ball narxi</label>
          <input v-model.number="form.ball_price" type="number" class="finput" placeholder="0" min="0" step="1" />
        </div>

        <div class="field-group">
          <label class="active-toggle">
            <input type="checkbox" v-model="form.is_active" />
            <span>Faol</span>
          </label>
        </div>
      </div>

      <div class="modal-foot">
        <button class="btn-cancel-m" @click="close">Bekor</button>
        <button class="btn-save-m" @click="save" :disabled="loading">
          {{ loading ? 'Saqlanmoqda...' : 'Saqlash' }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'AksiyaProductForm',
  props: {
    value:    { type: Boolean, default: false },
    aksiyaId: { type: Number, required: true },
    editItem: { type: Object, default: null },
  },
  data() {
    return {
      loading: false,
      form: { id: null, name: '', ball_price: 0, is_active: true },
      file: null,
      previewUrl: '',
    };
  },
  watch: {
    value(v) { if (v) this.loadFromProp(); },
  },
  mounted() { this.loadFromProp(); },
  methods: {
    loadFromProp() {
      if (this.editItem && this.editItem.id) {
        this.form = {
          id:         this.editItem.id,
          name:       this.editItem.name || '',
          ball_price: Number(this.editItem.ball_price || 0),
          is_active:  !!this.editItem.is_active,
        };
        this.previewUrl = this.editItem.image || '';
      } else {
        this.form = { id: null, name: '', ball_price: 0, is_active: true };
        this.previewUrl = '';
      }
      this.file = null;
    },
    close() { this.$emit('input', false); },

    onFileChange(e) {
      const f = e.target.files[0];
      if (!f) return;
      this.file = f;
      this.previewUrl = URL.createObjectURL(f);
    },

    async save() {
      if (!this.form.name.trim()) return alert('Nomini kiriting!');
      if (!this.form.ball_price || this.form.ball_price <= 0) return alert('Ball narxi 0 dan katta bo\'lishi kerak!');
      this.loading = true;
      try {
        const fd = new FormData();
        fd.append('aksiya_id', this.aksiyaId);
        fd.append('name', this.form.name.trim());
        fd.append('ball_price', this.form.ball_price);
        fd.append('is_active', this.form.is_active ? 'true' : 'false');
        if (this.file) fd.append('image', this.file);

        if (this.form.id) {
          await axios.patch(`/api/v1/ball-product/${this.form.id}`, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
        } else {
          await axios.post('/api/v1/ball-product', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
        }
        this.$emit('saved');
        this.close();
      } catch (e) {
        alert('Xatolik: ' + (e.response?.data?.message || e.message));
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.overlay {
  position: fixed; inset: 0;
  background: rgba(15, 23, 42, 0.55);
  z-index: 9500;
  display: flex; align-items: center; justify-content: center;
  backdrop-filter: blur(3px);
}
.modal-box {
  background: white; border-radius: 24px;
  width: 420px; max-width: 95vw;
  box-shadow: 0 24px 64px rgba(0,0,0,0.18);
  display: flex; flex-direction: column;
  max-height: 92vh; overflow: hidden;
}
.modal-head {
  padding: 22px 24px 16px;
  border-bottom: 1px solid #f1f5f9;
  display: flex; justify-content: space-between; align-items: center;
}
.modal-title { margin: 0; font-size: 18px; font-weight: 800; color: #1e293b; }
.close-btn {
  background: #f1f5f9; border: none;
  width: 34px; height: 34px; border-radius: 50%;
  font-size: 22px; cursor: pointer; color: #64748b;
  display: flex; align-items: center; justify-content: center;
}
.modal-body {
  padding: 20px 24px;
  overflow-y: auto;
  display: flex; flex-direction: column; gap: 14px;
}
.modal-foot {
  padding: 16px 24px;
  border-top: 1px solid #f1f5f9;
  display: flex; gap: 10px;
}

.image-uploader {
  height: 140px;
  background: #f8fafc;
  border: 2px dashed #cbd5e1;
  border-radius: 12px;
  cursor: pointer;
  overflow: hidden;
  display: flex; align-items: center; justify-content: center;
  transition: 0.15s;
}
.image-uploader:hover { border-color: #5850ec; background: #f5f3ff; }
.image-uploader img { width: 100%; height: 100%; object-fit: cover; }
.image-placeholder {
  text-align: center; color: #94a3b8;
  font-size: 12px; font-weight: 600;
  display: flex; flex-direction: column; gap: 4px;
}
.image-placeholder div:first-child { font-size: 28px; }

.field-group { display: flex; flex-direction: column; gap: 6px; }
.flabel { font-size: 12px; font-weight: 700; color: #64748b; text-transform: uppercase; letter-spacing: 0.3px; }
.finput {
  height: 44px;
  border: 1.5px solid #e2e8f0;
  border-radius: 12px;
  padding: 0 14px;
  font-size: 14px; font-weight: 600; color: #1e293b;
  outline: none; transition: 0.2s;
  width: 100%; box-sizing: border-box;
}
.finput:focus { border-color: #5850ec; box-shadow: 0 0 0 3px rgba(88,80,236,0.1); }

.active-toggle { display: flex; align-items: center; gap: 8px; cursor: pointer; user-select: none; }
.active-toggle input { width: 18px; height: 18px; cursor: pointer; }
.active-toggle span { font-weight: 700; color: #475569; }

.btn-cancel-m {
  flex: 1; height: 46px;
  background: #f1f5f9; color: #64748b;
  border: none; border-radius: 14px;
  font-weight: 700; cursor: pointer;
}
.btn-save-m {
  flex: 2; height: 46px;
  background: linear-gradient(135deg, #5850ec, #4338ca);
  color: white; border: none; border-radius: 14px;
  font-weight: 800; cursor: pointer;
  transition: 0.2s;
}
.btn-save-m:disabled { opacity: 0.6; }
</style>
